import React from "react";
import Hero from "./Hero";
import Exercise from "./Exercise";
import Start from "./Start";

const Home = () => {
  return (
    <>
      <Hero />
      <Exercise />
      <Start />
    </>
  );
};

export default Home;
